export default {"src":"/_next/static/media/LHX.674f9654.svg","height":18,"width":18};